import { createContext } from "react";

const Context = createContext({
  loggedIn: false,
  user: null,
});

export default Context;
